module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_9005.887b027f.png";